module.exports = __webpack_public_path__ + "img/shotchart.8c1fe6cd.png";